const base_url = "https://api-web-app-prod.azurewebsites.net/";
const details_url: string = window.location.origin + "/";
const white = "#FFFFFF";
const black = "#2C3338";
const password = "password";
const client_id = "client";
const tracking_id = "G-50KE52Z3C4";
const gtm_tracking_id = "GTM-NJNLWCPZ";
export { white, black, base_url, client_id, password, details_url, tracking_id, gtm_tracking_id}
